const artistsWishlistNL = {
    "view": {
        "table": {
            "title": "Je artiestenverlanglijst",
            "column": {
                "artist_name": "Artiestnaam",
                "spotify_id": "Spotify ID",
                "followers": "Volgers",
                "popularity": "Populariteit (%)",
                "action": "Actie"
            },
            "dropdown": {
                "action": "Actie",
                "addAsArtist": "Toevoegen als artiest",
                "delete": "Verwijderen"
            },
            "button": {
                "export_csv": "Exporteer CSV"
            },
            "placeholder": {
                "search": "Zoeken..."
            },
            "message": {
                "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!"
            }
        },
        "modal": {
            "removeArtist": {
                "header": "Verwijder artiest {{artistName}} van verlanglijst",
                "body": "Weet je zeker dat je artiest {{artistName}} van je verlanglijst wilt verwijderen?"
            }
        },
        "message": {
            "subscriptionUpgrade": "Je huidige abonnementsplan ondersteunt deze functie niet. Gelieve je abonnementsplan te <1>upgraden</1> om deze functie te gebruiken.",
            "subscriptionExpired": "Je abonnement is verlopen. Gelieve je abonnement te <1>hervatten</1> om deze functie te gebruiken.",
            "noAccess": "Je hebt geen toegang tot deze module, neem contact op met het ondersteuningsteam voor meer informatie."
        }
    }
};

export default artistsWishlistNL;